const KEY = 'offlineChangesQueue';

export function getQueue() {
  try {
    const raw = localStorage.getItem(KEY);
    // console.log('[getQueue] raw', raw);
    return raw ? JSON.parse(raw) : [];
  } catch (_) {
    return [];
  }
}

export function setQueue(queue) {
  try {
    localStorage.setItem(KEY, JSON.stringify(queue || []));
  } catch (_) {}
}

export function addItem(item) {
  const key = item.key || Math.random().toString(36).slice(2);
  const entry = { key, ts: Date.now(), ...item };
  const q = getQueue();
  // Do not prune here. Keep full history so UI can show and verifier can
  // resolve prior ops (create/update) as synced once a delete is confirmed.
  q.push(entry);
  setQueue(q);
  return entry;
}

export function updateItem(key, partial) {
  const q = getQueue();
  const idx = q.findIndex((i) => i.key === key);
  if (idx !== -1) {
    q[idx] = { ...q[idx], ...partial };
    setQueue(q);
    return q[idx];
  }
  return null;
}

export function removeItem(key) {
  const q = getQueue().filter((i) => i.key !== key);
  setQueue(q);
}

export function clearQueue() {
  setQueue([]);
}



